var _path;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgPluss(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 12,
    height: 12,
    viewBox: "0 0 12 12",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M6.41667 2.91667H5.25V5.25H2.91667V6.41667H5.25V8.75H6.41667V6.41667H8.75V5.25H6.41667V2.91667ZM5.83333 0C2.61917 0 0 2.61917 0 5.83333C0 9.0475 2.61917 11.6667 5.83333 11.6667C9.0475 11.6667 11.6667 9.0475 11.6667 5.83333C11.6667 2.61917 9.0475 0 5.83333 0ZM5.83333 10.5C3.26083 10.5 1.16667 8.40583 1.16667 5.83333C1.16667 3.26083 3.26083 1.16667 5.83333 1.16667C8.40583 1.16667 10.5 3.26083 10.5 5.83333C10.5 8.40583 8.40583 10.5 5.83333 10.5Z",
    fill: "#222222"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgPluss);
export default __webpack_public_path__ + "static/media/Pluss.b366b093ab115697b4bb992550880fec.svg";
export { ForwardRef as ReactComponent };